export default function(state=[], action) {

    switch(action.type) {
        case "ROLES":
            return action.payload;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerRoles.js